import { ReactNode } from 'react';
import { CoursesIds } from '../constants';

export const getPreSubmitPercent = (courseId: number) => {
  return courseId === CoursesIds.CPH_ID ? '60%' : '50%';
};

export const buildPreSubmitContent = (caseType: string, courseId: number): { title: string; message: ReactNode } => {
  const percent = getPreSubmitPercent(courseId);
  const upperType = caseType === 'psychological' ? 'PSYCHOLOGICAL' : 'COMPLEX';
  const message = (
    <>
      {`You're submitting a ${upperType} case with LESS THAN 4 SESSIONS.`}
      <br />
      <br />
      {`Please be sure your case shows ${percent} or more improvement AND includes follow up notes `}
      <em>1 week or more after the last session</em>
      {' reflecting that improvement has been sustained.'}
    </>
  );
  return { title: upperType, message };
};

export const needsPreSubmitModal = (
  caseType: string,
  courseId: number | undefined,
  sessionCount: number
) => {
  if (!courseId) return false;
  if (sessionCount >= 4) return false;
  if (!(caseType === 'complex' || caseType === 'psychological')) return false;
  if (!(courseId === CoursesIds.APH_ID || courseId === CoursesIds.CPH_ID)) return false;
  return true;
};